import React, { Fragment, useEffect, useState } from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/free-solid-svg-icons'

// router
import { withRouter } from 'react-router-dom'

// models
import ItemHistorialStock from './ItemHistorialStock'

// services
import {
    getHistorialStockByArticulo,
    historialMovimientosFromResponse,
    isHistorialTruncated,
} from '../../../Services/stockSucursalService'

// Sweet Alert
import Swal from 'sweetalert2'

export const historialModalId = (trigger, articuloId) =>
    trigger === 'name'
        ? 'modalHistorialStockInforme'
        : 'modalHistorialStock' + articuloId

const ModalHistorialStock = ({
    articuloId,
    articuloNombre,
    sucursalId,
    filters,
    headerLabel = 'Stock',
    headerValue,
    subtitleLabel,
    subtitleValue,
    trigger = 'button',
}) => {
    const [historial, setHistorial] = useState([])
    const [truncated, setTruncated] = useState(false)
    const modalId = historialModalId(trigger, articuloId)
    const leftoverFiltersKey = [
        filters && filters.from,
        filters && filters.to,
        filters && filters.size,
        filters && Array.isArray(filters.motivoNotIn)
            ? filters.motivoNotIn.join(',')
            : '',
    ].join('|')

    const applyHistorialResponse = (res) => {
        setHistorial(historialMovimientosFromResponse(res))
        setTruncated(isHistorialTruncated(res))
    }

    const getHistorialStock = () => {
        if (!sucursalId || !articuloId) return
        getHistorialStockByArticulo(sucursalId, articuloId, filters)
            .then(applyHistorialResponse)
            .catch((error) => {
                setHistorial([])
                setTruncated(false)
                Swal.fire({
                    type: 'error',
                    title: 'Error',
                    text: 'Hubo un error vuelve a intentar!',
                })
                console.log(error.response)
            })
    }

    useEffect(() => {
        if (trigger !== 'name') return
        if (!sucursalId || !articuloId) return
        getHistorialStock()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trigger, sucursalId, articuloId, leftoverFiltersKey])

    return (
        <Fragment>
            {trigger === 'button' && (
                <button
                    type="button"
                    className="btn text-info"
                    data-toggle="modal"
                    data-target={'#' + modalId}
                    onClick={() => getHistorialStock()}
                >
                    <FontAwesomeIcon icon={faList} /> Historial
                </button>
            )}

            <div
                className="modal fade"
                id={modalId}
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalHistorialStockTitle"
                aria-hidden="true"
            >
                <div
                    className="modal-dialog modal-dialog-scrollable"
                    role="document"
                >
                    <div className="modal-content">
                        <div className="modal-header justify-content-center">
                            <h5
                                className="modal-title"
                                id="modalHistorialStockTitle"
                            >
                                <b>Historial Stock Articulo</b>
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <p className="col-md">
                                    <b>Articulo:</b>
                                </p>
                                <p className="col-md">
                                    <b>{headerLabel}:</b>
                                </p>
                            </div>
                            <div className="row">
                                <p className="col-md">{articuloNombre}</p>
                                <p className="col-md">{headerValue}</p>
                            </div>
                            {subtitleLabel != null && subtitleLabel !== '' && (
                                <div className="row">
                                    <p className="col-md">
                                        <b>{subtitleLabel}:</b> {subtitleValue}
                                    </p>
                                </div>
                            )}
                            {truncated && (
                                <p
                                    className="mt-3 mb-0 alert alert-warning"
                                    role="status"
                                >
                                    El listado está truncado. Se muestran como
                                    máximo 1000 movimientos del período.
                                </p>
                            )}
                            <table className="table table-striped mt-3 text-center">
                                <thead>
                                    <tr>
                                        <th scope="col">Antes</th>
                                        <th scope="col">Después</th>
                                        <th scope="col">Motivo</th>
                                        <th scope="col">Fecha</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historial.map((stock) => (
                                        <ItemHistorialStock
                                            key={stock.id}
                                            stock={stock}
                                        />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-dismiss="modal"
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(ModalHistorialStock)
